'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collection = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CmsModules = require('containers/CmsPage/CmsModules');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collection = exports.Collection = function (_Component) {
  (0, _inherits3.default)(Collection, _Component);

  function Collection(props) {
    (0, _classCallCheck3.default)(this, Collection);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Collection.__proto__ || (0, _getPrototypeOf2.default)(Collection)).call(this, props));

    _this.renderItem = _this.renderItem.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Collection, [{
    key: 'renderItem',
    value: function renderItem(item, idx) {
      return _react2.default.createElement(
        'li',
        {
          key: 'item-' + idx,
          className: 'collection__item'
        },
        _react2.default.createElement(_CmsModules.CmsModules, { modules: [item] })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          modules = _props.modules,
          maxColumns = _props.maxColumns,
          extraClass = _props.extraClass;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('collection collection--col' + maxColumns, extraClass) },
        _react2.default.createElement(
          'ul',
          null,
          modules.map(this.renderItem)
        )
      );
    }
  }]);
  return Collection;
}(_react.Component);

Collection.propTypes = {
  extraClass: _propTypes2.default.string,
  modules: _propTypes2.default.array,
  maxColumns: _propTypes2.default.oneOf([1, 2, 3, 4]).isRequired
};